// Promo pruh nad headerem — červená varianta z design/SiteHeader.dc.html.
//
// Nativní `div.top-navigation-bar` žádný takový pruh nemá, vkládáme ho jako
// sourozence TĚSNĚ PŘED něj (mimo #header → odscrolluje, sticky není).
// Idempotentní.
//
// Pozn.: handoff (screens/01-header.md §1) označoval za schválenou variantu 1b
// „tmavý trust bar". Tomáš 2026-07-30 rozhodl vrátit se k červenému promo pruhu
// z mockupu — trust signály (4,8/5, skladem) tím z headeru mizí a žijí dál
// v patičce a v panelu hodnocení na homepage.
//
// Práh dopravy zdarma se čte z Shoptet dataLayeru (na dev instanci 2 000 Kč);
// mockup má 1 200 Kč, ale číslo je datová věc shopu, ne designu.
//
// Dvě varianty sdělení (rozhodnutí Tomáše 2026-09-03 „bez prahu z dataLayeru
// žádný slib"): dokud má košík na dopravu zdarma nárok (nebo je prázdný), pruh
// nese větu o dopravě zdarma; košík BEZ nároku (`freeShippingFrom: null` —
// nadrozměr, od hmotnostního tarifu i každý košík nad 10 kg) dostane obecnou
// větu o Slevoakcích. Dřívější fallback „…při větším nákupu." u těžkého košíku
// lhal: větší nákup by dopravu zdarma nepřinesl. Pruh se po AJAX změně košíku
// (odebrání těžké položky) přepíná živě.

import { icon } from './icon.js';
import { money } from './money.js';
import { shoptetData, onCartUpdated } from '../shoptet-hooks.js';
import { freeShipExcluded, shippingPromo, FREE_SHIP_FROM_FALLBACK } from './shippingModel.js';
import { deliveryTimeline, shortDate } from './deliveryTimeline.js';
import { page } from './pages.js';
import { NBSP } from './money.js';
import { activeCampaign, trackPromo } from './campaign.js';
import L from '../locale/cs/promoBar.js';

// „Doplnit zásoby" v mockupu nemá cíl. Míříme na Slevoakce — jediná akční
// nákupní stránka, která na shopu existuje (ověřeno, /slevoakce/ vrací 200).
const SALE_HREF = page('sale');

// Znění (rozhodnutí Tomáše 2026-08-25, ruší mockupové „Už pouze dnes …"):
//   • „už pouze dnes" u trvalého nastavení adminu je falešná časová tíseň,
//   • doprava zdarma platí JEN na výdejní místo (GLS/PPL), na adresu se platí
//     vždy — bez rozsahu pruh sliboval víc, než shop plní.
// Rozsah i práh proto stojí MIMO `.bs-promobar__tail`, který mobil skrývá;
// v tailu zůstávají jen slova, jejichž ztráta větu nezmění („při nákupu").
const SHIP = {
  key: 'ship',
  icon: 'truck',
  strong: L.shipStrong,
  lead: L.shipLead,
  tail: L.shipTail,
  cta: L.shipCta,
};
// Obecné akce v kategorii Slevoakce (Tomáš 2026-09-03) — bez čísel a bez
// termínu, aby pruh neplatil jen do konce jedné akce; konkrétní odpočet nese
// zóna SLEVOAKCE na homepage z admin bloku `#bs-sale`.
const SALE = {
  key: 'sale',
  icon: 'percent',
  strong: L.saleStrong,
  lead: L.saleLead,
  tail: L.saleTail,
  cta: L.saleCta,
};
// Zvláštní závoz dopravce (zadání Tomáše 2026-09-10). V okně, kdy GLS veze
// v sobotu (čt 15:00 → pá 14:30) nebo PPL sváží v neděli s doručením v pondělí
// (pá 14:30 → so 24:00), je to nejzajímavější zpráva týdne a pruh ji staví PŘED
// dopravu zdarma i Slevoakce. Okno počítá `deliveryTimeline()` (FAST_RULES) —
// jeden model pro osu detailu, modal dopravy, krok 2 pokladny i tenhle pruh,
// takže se znění nemůžou rozejít; mimo okno je `t.fast` null a pruh se chová
// jako dřív. Termín se tu bere BEZ nativního `div.delivery-time`: pruh visí na
// každé stránce a mluví o rytmu skladu, ne o konkrétním zboží.
//
// Deadline („objednejte …") jde z `t.fast.order`, tedy z téhož modelu jako osa
// na detailu — ve čtvrtek po cut-offu i v sobotu je to pravdivé „dnes do
// půlnoci" (expedice je stejně až další pracovní den), v pátek dopoledne „dnes
// do 14:30" a v pátek večer „do sobotní půlnoci".
//
// Pořadí sdělení: košík BEZ nároku na dopravu zdarma (`freeShipExcluded` —
// nadrozměr, zásilka nad 10 kg) drží Slevoakce i v okně závozu. Nadrozměr veze
// Fofr, ne GLS ani PPL, a slib sobotní doručení by mu lhal — stejná zásada jako
// u dopravy zdarma (Tomáš 2026-09-03 „bez prahu žádný slib"). Mimo tenhle
// případ (prázdný košík, běžná zásilka) má rychlý závoz přednost před oběma
// dosavadními větami. Nabídku metod šablona zná jen na detailu a v košíku,
// proto věta jmenuje dopravce („s GLS" / „s PPL") a slibuje jen za něj.
const FAST_DAY = L.fastDay;
const FAST_STRONG = L.fastStrong;
const FAST_ORDER = L.fastOrder;
// nedělní svoz je pro zákazníka nečekaný — pruh ho pojmenuje, ať pondělní
// termín po pátku nevypadá jako chyba
const FAST_SUNDAY = L.fastSunday;

const DISMISS_KEY = 'bs-promobar-dismissed';
const CLOSE_LABEL = L.close;
// jak často se přepočítá okno závozu — pruh přežije otevřenou záložku přes
// cut-off (v pátek ve 14:30 se překlopí z GLS na PPL)
const TICK_MS = 60000;


const formatPrice = (value) => money(value);

// Jaká věta a s jakým koncem. Doprava zdarma bez známého prahu (prázdný
// košík / dataLayer bez čísla) neslibuje částku: věta končí „…při větším
// nákupu." a vsuvka „ při nákupu" se NEkreslí — dřív tail zůstal a desktop
// četl „při nákupu při větším nákupu" (sonda probe-tarif, košík 31 kg).
// Sdělení o zvláštním závozu, nebo null mimo okno. `now` jde parametrem kvůli
// testům (tools/devcheck/header.mjs razí fáze okna přes page.clock).
export function fastMessage(now) {
  const t = deliveryTimeline(now, null);
  if (!t.fast) return null;
  const f = t.fast;
  return {
    v: {
      key: 'fast-' + f.key,
      icon: 'truck',
      strong: FAST_STRONG + FAST_DAY[f.key],
      // datum i dopravce drží pohromadě NBSP — pruh je jeden řádek a zlom
      // uprostřed „12. 9." nebo „s GLS" by ho rozhodil
      lead: NBSP + shortDate(f.deliverDate).replace(/ /g, NBSP) + ' ' + L.fastWith + NBSP + f.carrier,
      cta: SHIP.cta,
    },
    tail: (f.key === 'sun' ? FAST_SUNDAY : FAST_ORDER) + f.order,
    text: '.',
  };
}

// Akce na dopravu (#322, manifest `shipping.promo`): v okně akce nahrazuje
// dopravu zdarma i zvláštní závoz (mock M1 varianta a). Košík bez nároku na
// dopravu zdarma (nad 10 kg, nadrozměr) drží Slevoakce dál — akce platí jen
// do 10 kg a slib by mu lhal. Rozsah „do 10 kg" stojí v `lead`, ne v tailu,
// který mobil skrývá; tail nese jen konec akce a práh dopravy zdarma.
export function promoMessage(cartInfo, now) {
  const pr = shippingPromo(now);
  if (!pr) return null;
  const free = money((cartInfo && cartInfo.freeShippingFrom) || FREE_SHIP_FROM_FALLBACK);
  return {
    v: {
      key: 'promo-' + pr.id,
      icon: 'truck',
      strong: L.promoStrong(pr.carrier, money(pr.price)),
      lead: L.promoLead(pr.maxKg),
      cta: SHIP.cta,
    },
    tail: L.promoTail(free, pr.untilLabel),
    text: '.',
  };
}

// Deštník kampaně (campaign.js, plán kampaní 6. 10.): „ŘÍJNOVÝ VÝPRODEJ ·
// výprodej skladu až −30 %" s odkazem na akční nabídku. Věta se vejde do
// jednoho mobilního řádku (≤ 45 znaků), proto nemá tail ani termín — výprodej
// nekončí datem, po kterém by cena skončila (pravidla textů plánu).
export function campaignMessage(now) {
  const c = activeCampaign(now);
  if (!c) return null;
  return {
    v: {
      key: 'campaign-' + c.id,
      icon: 'percent',
      strong: c.t.barStrong,
      lead: c.t.barLead(c.claim),
      cta: c.t.barCta,
    },
    tail: null,
    text: '',
    href: c.href,
    campaign: c,
  };
}

function baseMessage(cartInfo, now) {
  if (freeShipExcluded(cartInfo)) return { v: SALE, tail: SALE.tail, text: '.' };
  const promo = promoMessage(cartInfo, now);
  if (promo) return promo;
  const fast = fastMessage(now);
  if (fast) return fast;
  const price = formatPrice(cartInfo && cartInfo.freeShippingFrom);
  return price ? { v: SHIP, tail: SHIP.tail, text: L.over(price) } : { v: SHIP, tail: null, text: L.bigger };
}

// Sdělení pruhu v pořadí střídání. Po dobu kampaně jde deštník první a za ním
// dosavadní zpráva (akce na dopravu, závoz, doprava zdarma). Košík bez nároku
// na dopravu zdarma by dostal obecnou větu o Slevoakcích — tu deštník nahrazuje
// celou, dvě zprávy o slevách za sebou by nic nepřidaly.
export function messages(cartInfo, now) {
  const campaign = campaignMessage(now);
  const base = baseMessage(cartInfo, now);
  if (!campaign) return [base];
  if (base.v === SALE) return [campaign];
  return [campaign, base];
}

function dismissed() {
  try {
    return window.sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch (e) {
    return false;
  }
}

function remember() {
  try {
    window.sessionStorage.setItem(DISMISS_KEY, '1');
  } catch (e) {
    /* private mode — pruh se prostě vrátí po reloadu */
  }
}

// Věta sdělení: tučné jádro, rozsah, vsuvka (`tail`) a konec věty.
function sentence(text, m) {
  const strong = document.createElement('b');
  strong.textContent = m.v.strong;
  text.appendChild(strong);
  text.appendChild(document.createTextNode(m.v.lead));
  // Vsuvka nese vlastní span — mobil ho skrývá, aby pruh držel jeden řádek
  // (m01-header.md §1); rozsah i práh zůstávají čitelné i bez něj.
  if (m.tail) {
    const tail = document.createElement('span');
    tail.className = 'bs-promobar__tail';
    tail.textContent = m.tail;
    text.appendChild(tail);
  }
  if (m.text) text.appendChild(document.createTextNode(m.text));
}

// Jedno sdělení = slide (ikona · věta · CTA). Na mobilu CTA chip není vidět
// (věta potřebuje celou šířku), ale odkaz zůstává: CSS ho roztáhne přes celý
// pruh, takže tap kamkoliv vede na cíl CTA a čtečka má jeden odkaz s textem.
// Zavírací křížek leží nad ním.
function slideNode(m) {
  const slide = document.createElement('div');
  slide.className = 'bs-promobar__slide';
  slide.dataset.bsKey = m.v.key;
  slide.appendChild(icon(m.v.icon));
  const text = document.createElement('span');
  text.className = 'bs-promobar__text';
  sentence(text, m);
  slide.appendChild(text);
  const cta = document.createElement('a');
  cta.className = 'bs-promobar__cta';
  cta.href = m.href || SALE_HREF;
  cta.textContent = m.v.cta;
  slide.appendChild(cta);
  if (m.campaign) trackPromo(slide, m.campaign, 'promo_bar');
  return slide;
}

// Střídání sdělení po dobu kampaně (deštník ↔ doprava): slide po ROTATE_MS,
// hover a focus ho pozastaví (WCAG 2.2.2), `prefers-reduced-motion` ho vypne
// a pruh drží první sdělení. Mění se jen třída `is-active` (atribut, ne
// childList), observery košíku ani pokladny tik nevidí jako výměnu obsahu.
const ROTATE_MS = 6000;

function reducedMotion() {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}

function showSlide(inner, index) {
  const slides = inner.querySelectorAll(':scope > .bs-promobar__slide');
  slides.forEach(function (s, i) {
    const on = i === index;
    s.classList.toggle('is-active', on);
    if (on) s.removeAttribute('aria-hidden');
    else s.setAttribute('aria-hidden', 'true');
    // skrytý slide nesmí brát fokus tabulátorem
    s.querySelectorAll('a').forEach(function (a) {
      if (on) a.removeAttribute('tabindex');
      else a.setAttribute('tabindex', '-1');
    });
  });
  inner.dataset.bsSlide = String(index);
}

function rotate(inner) {
  const slides = inner.querySelectorAll(':scope > .bs-promobar__slide');
  if (slides.length < 2 || reducedMotion()) return;
  if (inner.matches(':hover') || inner.contains(document.activeElement)) return;
  showSlide(inner, (Number(inner.dataset.bsSlide || 0) + 1) % slides.length);
}

// Obsah pruhu; přestaví se jen při změně sdělení, ať AJAX košíku pruh
// zbytečně nepřekresluje (a střídání nezačíná znovu od deštníku).
function render(inner) {
  const list = messages(shoptetData('cartInfo'));
  const sig = list
    .map(function (m) {
      return m.v.key + '|' + (m.tail || '') + '|' + m.text;
    })
    .join('||');
  if (inner.dataset.bsSig === sig) return;
  inner.dataset.bsSig = sig;
  inner.textContent = '';

  list.forEach((m) => inner.appendChild(slideNode(m)));
  inner.classList.toggle('bs-promobar__in--multi', list.length > 1);
  showSlide(inner, 0);
}

export function initPromoBar() {
  const topBar = document.querySelector('.top-navigation-bar');
  if (!topBar || document.querySelector('.bs-promobar')) return;
  if (dismissed()) return;

  const bar = document.createElement('div');
  bar.className = 'bs-promobar';

  const inner = document.createElement('div');
  inner.className = 'container bs-promobar__in';
  bar.appendChild(inner);
  render(inner);

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'bs-promobar__close';
  close.setAttribute('aria-label', CLOSE_LABEL);
  close.appendChild(icon('close'));
  close.addEventListener('click', function () {
    bar.remove();
    remember();
  });
  bar.appendChild(close);

  topBar.parentNode.insertBefore(bar, topBar);

  // košík se mění AJAXem (stepper, odebrání položky, přidání z detailu) —
  // ShoptetCartUpdated na detailu nelétá, tam stav nese ShoptetDataLayerUpdated
  const refresh = function () {
    if (bar.isConnected) render(inner);
  };
  onCartUpdated(refresh);
  document.addEventListener('ShoptetDataLayerUpdated', refresh);

  // okno závozu se láme v cut-off a o půlnoci — bez tiku by pruh na dlouho
  // otevřené záložce sliboval sobotu i v pátek večer. `render()` přestaví obsah
  // jen při změně signatury, takže tik nic nepřekresluje zbytečně.
  const tick = window.setInterval(function () {
    if (!bar.isConnected) {
      window.clearInterval(tick);
      return;
    }
    render(inner);
  }, TICK_MS);

  const turn = window.setInterval(function () {
    if (!bar.isConnected) {
      window.clearInterval(turn);
      return;
    }
    rotate(inner);
  }, ROTATE_MS);
}
